module.exports = __webpack_public_path__ + "static/media/vignet_example.5d920af0.jpg";